import quillConfig from '@/quill/config'

/**
 * Slim toolbar for message composers (email replies / new messages). Reuses the
 * shared modules (link, clipboard, imageBlocker, keyboard) but exposes only the
 * formatting a support reply needs — no headers, alignment, strike or placeholder
 * variables, which belong to CMS content editing, not correspondence.
 */
const composerQuillConfig = {
    ...quillConfig,
    modules: {
        ...quillConfig.modules,
        toolbar: {
            container: [
                ['bold', 'italic', 'underline'],
                ['blockquote'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link'],
                ['text-generation'],
                ['clean']
            ]
        }
    }
}

export default composerQuillConfig
